import increaseColorPointByStep from '../utils/increase-color-point-by-step';
import reduceColorPointByStep from '../utils/reduce-color-point-by-step';

const primaryButtonHover = (params, isAccentBackground = false) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor, blackColor } = params;
  const fallback = {
    rule: 'primaryButton.background.hover',
    params,
  };

  if (targetColor.equals(targetColorPalette[900])) {
    return targetColorPalette[800];
  }

  if (targetColor.equals(whiteColor)) {
    return targetColorPalette[50];
  }

  if (targetColor.equals(targetColorPalette[50])) {
    return whiteColor;
  }

  if (targetColor.equals(blackColor)) {
    return targetColorPalette[900];
  }

  const reducedTargetColor = reduceColorPointByStep({
    targetColor,
    targetColorPalette,
    step: 1,
    fallback,
  });

  const increasedTargetColor = increaseColorPointByStep({
    targetColor,
    targetColorPalette,
    step: 1,
    fallback,
  });

  if (isAccentBackground && reducedTargetColor.equals(backgroundColor)) {
    return increasedTargetColor;
  }

  if (isAccentBackground && increasedTargetColor.equals(backgroundColor)) {
    return reducedTargetColor;
  }

  return reducedTargetColor;
};

export default primaryButtonHover;
